// src/components/PortfolioItem.jsx
import tamaImg from '../assets/img/projects/tamatask square.jpg';

const portfolioItems = [
	{
		id: 1,
		slug: 'tama',
		title: 'TamaTask Webapp',
		categories: ['Web'],
		selected: true,
		img: '../assets/img/projects/tamatask square-s.jpg',
		// miniaturas internas
		innerImages: [],
		clientFor: 'Personal Project',
		services: ['Figma', 'HTML', 'CSS', 'JavaScript (Vanilla)', 'LocalStorage', 'Vercel'], // Atualizado
		website: 'https://webapp-tamatask.vercel.app/',
		website2:
			'https://www.figma.com/design/cuYmLcbbvLbRUia7pP7JuY/tama-webapp?t=6NaXfWLnb5jb9b3M-1',
		// array de parágrafos
		overview: [
			'O projeto é uma aplicação web chamada TamaTask WebApp que combina gerenciador de tarefas, temporizador Pomodoro e um mascote virtual. A interface é inspirada em um Tamagotchi: o usuário pode alimentar, dar carinho e fazer o pet dormir, acumulando pontos de experiência (XP) e subindo de nível.',
		],

		text1: "Para criar uma experiência completa de produtividade e bem-estar, a aplicação integra diversas ferramentas essenciais. O usuário pode gerenciar suas atividades com uma **lista de tarefas** dinâmica, que permite adicionar e marcar itens como concluídos. Para o gerenciamento de tempo, foi implementado um **temporizador Pomodoro** completo, com controles para iniciar, pausar e reiniciar os ciclos de foco. A gamificação é um elemento central, visível nos **indicadores de progresso** (XP, tarefas, foco, comida, amor e descanso), que evoluem conforme as interações. O ambiente é complementado por um **player de músicas 'lo-fi'** com seleção de faixas e volume, e um **bloco de notas** para anotações rápidas, enquanto **notificações (toasts)** celebram as recompensas em XP, reforçando o engajamento.",
		text2: [
			'O código é totalmente em HTML, CSS e JavaScript (vanilla), sem frameworks. Há ainda um módulo opcional para usar localStorage e salvar o progresso do usuário (nível, XP e tarefas). Os assets incluem imagens do pet/reações e sons de aviso.',
			'“Gamificação” com funcionalidades de produtividade / manipulação do DOM, controle de áudio, animações por CSS e integração com APIs do navegador (como o localStorage).',
		],
	},
	{
		id: 14,
		slug: 'cidadaniaja',
		title: 'Case: Cidadania Já — Design de Campanha Multiplataforma',
		categories: ['Design'],
		thumbnailImg: '../assets/img/projects/cidadja-thumb.png',
		// img: '',
		innerImages: [''],
		clientFor: 'Cidadania Já',
		services: ['Design Gráfico', 'UI/UX', 'Motion', 'IA Generativa'],
		website:
			'https://www.figma.com/deck/KfzaT93P14czgqFfvdxRrS/Untitled?node-id=2-368&t=5oc9S7OlyvjKvuM5-1',
		overview: [
			`Projeto desenvolvido como estudo e demonstração de design estratégico para Cidadania Já. 
O desafio proposto pela Cidadania Já visava aprimorar a comunicação digital (landing page) e impressa (panfleto A5) para o serviço de busca de documentos para cidadania italiana. 
A meta principal era transformar informações complexas em uma mensagem clara, confiável e persuasiva, alinhada com o manual da marca e capaz de gerar leads qualificados através da pré-busca gratuita.`,
		],
		text1: 'A proposta do case foi criar uma identidade unificada e acessível para uma campanha de cidadania, com presença em mídias digitais, impressas e audiovisuais.',
		text2: [
			'Design de interface e identidade visual desenvolvidos no Figma.',
			'Aplicações gráficas para cartazes, banners e vídeos curtos.',
			'Utilização de IA generativa como auxílio.',
			'Photoshop, Figma, Illustrator, After Effects, Sora, Midjourney, Gemini',
		],
		embed: `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="https://embed.figma.com/slides/KfzaT93P14czgqFfvdxRrS/Untitled?node-id=2-368&embed-host=share" allowfullscreen></iframe>`,
	},
	{
		id: 12,
		slug: 'portfolio-2025',
		title: 'Portfólio 2025',
		categories: ['Web'],
		selected: true,
		img: '../assets/img/projects/portfolio 2025-s.jpg',
		innerImages: [],
		clientFor: 'Projeto Pessoal',
		services: [
			'React',
			'React Router',
			'jQuery',
			'Bootstrap',
			'Magnific Popup',
			'Slick Carousel',
			'HTML',
			'CSS',
			'Vercel',
		], // Atualizado
		website: 'https://www.madebyflavia.com/',
		overview: [
			'Este portfólio web foi desenvolvido com React, integrando o React Router para navegação entre páginas e componentes personalizados que organizam as seções como Home, Sobre, Serviços e Portfólio.',
			'Embora baseado em uma estrutura moderna com React, o projeto também incorpora recursos visuais legados utilizando jQuery, permitindo integrar plugins como Magnific Popup (para lightbox em galerias) e Slick Carousel (para sliders responsivos). Para isso, o carregamento inicial do app expõe jQuery no escopo global e aplica estilos adicionais por meio de arquivos CSS convertidos de JavaScript vanilla.',
		],
		text1: `O portfólio apresenta:

• Lista de projetos filtrável com categorias, carregada dinamicamente.

• Páginas de detalhes para cada projeto, acessadas via rota com slug (por exemplo, /portfolio/tama).

• Um script legado (legacy-home.js) que cuida de interações visuais como:
  – Alternância de modo escuro,
  – Menu mobile com animação,
  – Efeitos de transição nas galerias de imagem.`,
		text2: [
			'O layout é responsivo e foi iniciado a partir do Create React App. O projeto utiliza Bootstrap para estruturação de grid, React Icons para ícones personalizados e recursos adicionais herdados do template original em HTML/CSS.',
			'Principais tecnologias: React · React Router · jQuery · Bootstrap · Magnific Popup · Slick Carousel · HTML/CSS modularizado',
		],
	},
	{
		id: 2,
		slug: 'design-social',
		title: 'Trabalhos de design - Social Media',
		categories: ['Design'],
		img: './assets/img/images/socialmediacover.png',
		website: '/portfolio/design-social',
		services: ['[Galeria de imagens]'],
	},

	{
		id: 4,
		slug: 'design-slides',
		title: 'Trabalhos de design - Slides e Pitch Decks',
		categories: ['Design'],
		img: 'https://i.imgur.com/bWbqbbR.png',
		website: '/portfolio/design-slides',
		services: ['[Galeria de imagens]'],
	},
	{
		id: 5,
		slug: 'design-branding',
		title: 'Trabalhos de design - Branding e ID visual',
		categories: ['Design'],
		img: '../assets/img/projects/branding-thumb.png',
		website: '/portfolio/design-branding',
		services: ['[Galeria de imagens]'],
	},
	{
		id: 3,
		slug: 'design-diagramacao',
		title: 'Trabalhos de design - Diagramação',
		categories: ['Design'],
		img: 'https://i.imgur.com/AqNjAn6.png',
		website: '/portfolio/design-diagramacao',
		services: ['[Galeria de imagens]'],
	},
	{
		id: 6,
		slug: 'pawsitiva',
		title: 'Web Design Pawsitiva',
		categories: ['Web'],
		img: '../assets/img/projects/pawsitiva-thumb.png',
		innerImages: [],
		clientFor: 'Concept',
		services: ['Figma'], // Atualizado
		website: 'https://www.figma.com/design/VOdXNAVVW4MsxGN3rlHjNO/Wireframe-1?node-id=1-2',
		overview: ['Feito no figma, ainda não implementada'],
		text1: '',
		text2: [],
	},
	{
		id: 7,
		slug: 'studio-muza',
		title: 'Studio website',
		categories: ['Web'],
		img: '../assets/img/projects/studio-thumb.png',
		innerImages: [],
		clientFor: '',
		services: ['HTML', 'CSS', 'JavaScript (Vanilla)', 'jQuery', 'Bootstrap', 'Vercel'], // Atualizado
		website: 'https://studiomuza-32m8dcbc2-grimmbunnys-projects.vercel.app/',
		overview: ['Responsivo. HTML, CSS, vanilla JS & JQuery, Bootstrap.'],
		text1: '',
		text2: [],
	},
	{
		id: 8,
		slug: 'clone-disney',
		title: 'Clone da Disney+',
		categories: ['Web'],
		img: '../assets/img/projects/d+-thumb.png',
		innerImages: [],
		clientFor: 'Estudo',
		services: ['HTML', 'SASS', 'JavaScript (Vanilla)', 'Gulp', 'Vercel'], // Atualizado
		website: 'https://clone-disneyplus-bs1y5h2ac-grimmbunny.vercel.app/',
		overview: ['Responsivo. HTML, SASS, vanilla JS, Gulp.'],
		text1: '',
		text2: [],
	},
	{
		id: 9,
		slug: 'portfolio-dev',
		title: 'Personal portfolio Dev - Design 2023',
		categories: ['Web'],
		img: '../assets/img/projects/portold1-thumb.png',
		innerImages: [],
		clientFor: 'Projeto próprio',
		services: ['HTML', 'CSS', 'JavaScript (Vanilla)', 'Vercel'], // Atualizado
		website: 'https://madebyflavia.dev/',
		overview: ['Responsivo. HTML, CSS, vanilla JS.'],
		text1: '',
		text2: [],
	},
	// {
	// 	id: 10,
	// 	slug: 'portfolio-art',
	// 	title: 'Personal portfolio - Arte 2023',
	// 	categories: ['Web'],
	// 	img: 'https://i.imgur.com/1mzHhep.png',
	// 	innerImages: [],
	// 	clientFor: 'Projeto próprio',
	// 	services: ['HTML', 'CSS', 'JavaScript (Vanilla)', 'Vercel'], // Atualizado
	// 	website: 'https://madebyflavia.art/',
	// 	overview: ['Responsivo. HTML, CSS, vanilla JS.'],
	// 	text1: '',
	// 	text2: [],
	// },
	{
		id: 11,
		slug: 'landing-ebac',
		title: 'Clone landing page EBAC',
		categories: ['Web'],
		img: '../assets/img/projects/ebacclone-thumb.png',
		innerImages: [],
		clientFor: 'Estudo',
		services: ['HTML', 'SASS', 'JavaScript (Vanilla)', 'Parcel', 'Vercel'], // Atualizado
		website: 'https://landingpage-proj-mt39959mr-grimmbunny.vercel.app/',
		overview: ['Responsivo. HTML, SASS, vanilla JS, Parcel.'],
		text1: '',
		text2: [],
	},
	// {
	// 	id: 13,
	// 	slug: 'cliente1',
	// 	title: 'Portfolio',
	// 	categories: ['Web'],
	// 	img: '../assets/img/projects/cliente1.jpg',
	// 	innerImages: [],
	// 	clientFor: 'Adriana',
	// 	services: ['JavaScript', 'Vercel'], // Atualizado
	// 	website: 'https://demo-cliente1.vercel.app',
	// 	overview: ['Website desenvolvido como demonstração para o cliente 1.'],
	// 	text1: 'Projeto implementado utilizando JS e estilização personalizada.',
	// 	text2: ['Possui páginas institucionais e componentes reutilizáveis.'],
	// },
];

export default portfolioItems;
